import * as React from 'react';
import './_PushNotifications.scss';
import { IPushNotificationsProps } from './types';
import { Checkbox, Radio, Select } from 'kui';
import {
    BOARD_PUSH_NOTIFICATION_ANY,
    BOARD_PUSH_NOTIFICATION_IMPORTANT,
    BOARD_PUSH_NOTIFICATION_IMPORTANT_CHECKBOXES,
    BOARD_PUSH_NOTIFICATION_IMPORTANT_CHECKBOXES_KNB,
    BOARD_PUSH_NOTIFICATION_SEND_UPDATES,
    BOARD_PUSH_NOTIFICATION_SUBCRIBE,
    BOARD_PUSH_NOTIFICATION_SUBSCRIBE_ON_CHECKBOXES,
    BOARD_PUSH_NOTIFICATION_TYPE_CHECKBOXES,
    BOARD_PUSH_NOTIFICATION_TYPE_CHECKBOXES_KNB,
    BOARD_PUSH_NOTIFICATION_TYPE_RADIO,
    BOARD_PUSH_NOTIFICATION_WEB_PUSH_DISABLED,
    BOARD_PUSH_NOTIFICATION_WEB_PUSH_DISABLED_LINK,
    BOARD_PUSH_NOTIFICATION_WHEN,
} from './constants';
import { updateScopeList } from '../helpers/updateScopeList';
import {
    EPushNotificationSettingsScope,
    EPushNotificationSettingsTypes,
    EPushNotificationSubscribeCases
} from '../../../../../../../../types/rest/IRestPushNotificationSettings';
import { CLASS_BOARD_DETAILS } from '../../../../constants';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
import { root } from '../../../../../../../../store/constants';
import { CLASS_ASIDE_PANEL_HEADER } from '../../../../../asidePanel/components/AsidePanelHeader/constants';
import { GOOGLE_SPACING } from '../../../../../../../../const';
import { getWebPushEnabled } from '../../../../../../../../helper/webPushNotify';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`PushNotifications`) : null;

export function PushNotifications ({
    isEnabled,
    isKanbanchiUser,
    isReadonly,
    listChangeToOptions,
    listMoveToOptions,
    scopes,
    subscribeCases,
    types,
    onChange,
    onListChangeToToggle,
    onListMoveToToggle,
    onScopeClick,
    onNotifyTypeClick,
    onNotifySubscribeCaseClick,
    onOpenSettings,
    onShowBoardLimitSnackbarIfNeeded,
}: IPushNotificationsProps) {
    if (analyzeRender) analyzeRender.call(`PushNotifications`);
    const [scopeList, setScopeList] = React.useState(scopes);
    const [typesDisabled, setTypesDisabled] = React.useState(false);
    const [index, setIndex] = React.useState(null);

    const className = CLASS_BOARD_DETAILS + '__push-notifications';
    const classHeader = CLASS_BOARD_DETAILS  + '__push-header';
    const classLevel = CLASS_BOARD_DETAILS  + '__checkbox-level';
    const classChecklist = classLevel + '-checklist';
    const classSelect = classLevel + '-select';
    const classWrapper = className + '-wrapper';

    const radioValues = BOARD_PUSH_NOTIFICATION_TYPE_RADIO.map((item) => item.value);

    const getIndex = () => {
        for (let i = 0; i < radioValues.length; i++) {
            let index;
            if (scopes.includes(radioValues[i])) {
                index = i
                return index
            }
        }
    }

    const onScopeChangeHandler = (scope: EPushNotificationSettingsScope) => {
        onScopeClick(scope, !scopeList.includes(scope));
        let _scopeList: EPushNotificationSettingsScope[];
        if (radioValues.includes(scope)) {
            _scopeList = scopeList.filter((item) => !radioValues.includes(item))
            _scopeList.push(scope)
        } else {
            _scopeList = updateScopeList<EPushNotificationSettingsScope>(scope, scopeList);
        }
        let _subscribeCases = [...subscribeCases];
        if (scope === EPushNotificationSettingsScope.ALL || scope === EPushNotificationSettingsScope.ASSIGN_TO_ME ) {
            _subscribeCases = [];
        }
        onChange(_scopeList, _subscribeCases, types);
    }
    const onTypeChangeHandler = (type: EPushNotificationSettingsTypes) => {
        onNotifyTypeClick(type, !types.includes(type));
        const _types = updateScopeList<EPushNotificationSettingsTypes>(type, types);
        onChange(scopes, subscribeCases, _types);
    }
    const onSubscribeCaseChangeHandler = (subscribeCase: EPushNotificationSubscribeCases) => {
        onNotifySubscribeCaseClick(subscribeCase, !subscribeCases.includes(subscribeCase));
        const _subscribeCases = updateScopeList<EPushNotificationSubscribeCases>(subscribeCase, subscribeCases);
        let _scopes = [...scopes];
        if (!_scopes.includes(EPushNotificationSettingsScope.WATCH)) {
            _scopes = scopeList.filter((item) => !radioValues.includes(item))
            _scopes.push(EPushNotificationSettingsScope.WATCH)
        }
        onChange(_scopes, _subscribeCases, types);
    }

    React.useEffect(() => {
        setScopeList(scopes);
        setTypesDisabled(
            !scopes.includes(EPushNotificationSettingsScope.ALL) &&
            !scopes.includes(EPushNotificationSettingsScope.WATCH) &&
            !scopes.includes(EPushNotificationSettingsScope.ASSIGN_TO_ME));
        setIndex(getIndex())
    }, [scopes]);

    const [isWebPushEnabled, setWebPushEnabled] = React.useState(getWebPushEnabled());
    const timerRef = React.useRef(null);
    React.useEffect(() => { // не лежит в сторе, поэтому нужно постоянно следить
        if (timerRef) clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setWebPushEnabled(getWebPushEnabled());
        }, 200);
        return () => {
            if (timerRef) clearInterval(timerRef.current);
        }
    }, []);

    const [isOpen, setOpen] = React.useState(null);
    React.useEffect(() => {
        const onResize = () => {
            const dropdown = document.querySelector(`.${className}-select-dropdown .kui-dropdown__item`) as HTMLElement;
            if (dropdown) {
                const header = document.querySelector(`.${CLASS_ASIDE_PANEL_HEADER}`) as HTMLElement;
                if (!header) return;
                dropdown.style.maxHeight = `${parseInt(dropdown.style.maxHeight) - header.offsetHeight - GOOGLE_SPACING}px`;
            }
        };
        if (isOpen) {
            setTimeout(() => { // ждем дропдаун
                onResize()
            }, 200);
        }
        root.addEventListener('resize', onResize);
        return () => root.removeEventListener('resize', onResize);
    }, [isOpen]);

    React.useEffect(() => {
        const input = document.querySelector(`.${classSelect}--${EPushNotificationSettingsTypes.LIST_CHANGE} .kui-input__item`) as HTMLInputElement;
        if (!input) return;
        const value = listChangeToOptions
            .filter(item => item.active)
            .map(item => item.text)
            .join(', ');
        input.value = value ? value : BOARD_PUSH_NOTIFICATION_ANY;
    }, [listChangeToOptions]);

    React.useEffect(() => {
        const input = document.querySelector(`.${classSelect}--${EPushNotificationSettingsScope.MOVE_TO_SPECIFIC_LIST} .kui-input__item`) as HTMLInputElement;
        if (!input) return;
        input.value = listMoveToOptions
            .filter(item => item.active)
            .map(item => item.text)
            .join(', ');
    }, [listMoveToOptions]);

    React.useEffect(() => {
        if (!isOpen) return;
        setTimeout(() => { // ждем открытия
            const dd = document.querySelector(`.${className}-select-dropdown .kui-dropdown__item`) as HTMLElement;
            if (!dd) return;
            dd.addEventListener('click', e => {
                const target = e.target as HTMLElement;
                if (
                    target?.className?.includes && (
                        target.className.includes('kui-dropdown__item') ||
                        target.className.includes('kui-select-list') ||
                        target.className.includes('kui-label')
                    )) {
                    e.preventDefault();
                }
            });
        }, 200);
    }, [isOpen]);

    return (
        <div
            className={className}
        >
            {!isWebPushEnabled && <div className={className + '-web'}>
                {BOARD_PUSH_NOTIFICATION_WEB_PUSH_DISABLED}
                <a onClick={onOpenSettings}>{BOARD_PUSH_NOTIFICATION_WEB_PUSH_DISABLED_LINK}</a>
            </div>}
            {isEnabled &&
                <>
                    <div
                        className={classHeader}
                    >
                        {BOARD_PUSH_NOTIFICATION_SEND_UPDATES}
                    </div>
                    <div className={classWrapper} onClick={onShowBoardLimitSnackbarIfNeeded}>
                        <Radio
                            className={className + '--radio'}
                            active={index}
                            direction={'left'}
                            onChange={ e => onScopeChangeHandler(BOARD_PUSH_NOTIFICATION_TYPE_RADIO[e.index].value)}
                        >
                            {
                                BOARD_PUSH_NOTIFICATION_TYPE_RADIO.map(item => {
                                    const {title, value} = item
                                    if (!scopeList.includes(EPushNotificationSettingsScope.ASSIGN_TO_ME) && value === EPushNotificationSettingsScope.ASSIGN_TO_ME) return
                                    return (
                                        <span
                                            className={`${className}-item ${className}-item--${value} ${isReadonly ? 'disabled' : ''}`}
                                            key={value}
                                        >
                                {title}
                            </span>
                                    )
                                })
                            }
                        </Radio>
                    </div>
                    <div className={classLevel}>
                        <div
                            className={classHeader}
                        >
                            {BOARD_PUSH_NOTIFICATION_SUBCRIBE}
                        </div>
                        <div className={classWrapper} onClick={onShowBoardLimitSnackbarIfNeeded}>
                            {BOARD_PUSH_NOTIFICATION_SUBSCRIBE_ON_CHECKBOXES.map((cb) =>
                                <Checkbox
                                    key={cb.value}
                                    checked={subscribeCases.includes(cb.value as EPushNotificationSubscribeCases)}
                                    disabled={isReadonly}
                                    value={cb.value as EPushNotificationSettingsScope}
                                    onChange={() => onSubscribeCaseChangeHandler(cb.value as EPushNotificationSubscribeCases)}
                                >
                                    {cb.title}
                                </Checkbox>)
                            }
                        </div>
                    </div>
                    <div
                        className={classHeader}
                    >
                        {BOARD_PUSH_NOTIFICATION_WHEN}
                    </div>
                    <div className={classWrapper} onClick={onShowBoardLimitSnackbarIfNeeded}>
                        {(isKanbanchiUser ? BOARD_PUSH_NOTIFICATION_TYPE_CHECKBOXES_KNB :BOARD_PUSH_NOTIFICATION_TYPE_CHECKBOXES).map((cb) =>
                            <Checkbox
                                className={`${classChecklist} ${cb.isListSelect ? classChecklist + '--select' : ''}`}
                                key={cb.value}
                                checked={types.includes(cb.value as EPushNotificationSettingsTypes)}
                                disabled={isReadonly || typesDisabled}
                                value={cb.value as EPushNotificationSettingsTypes}
                                onChange={() => onTypeChangeHandler(cb.value as EPushNotificationSettingsTypes)}
                            >
                                {cb.title}
                                {cb.isListSelect &&
                                <Select
                                    className={`${classSelect} ${classSelect}--${cb.value}`}
                                    disabled={isReadonly}
                                    dropdownClassName={className + '-select-dropdown'}
                                    onChange={(e) => {
                                        const { value } = e.target as HTMLOptionElement;
                                        onListChangeToToggle(parseInt(value));
                                    }}
                                    onOpen={() => setOpen(true)}
                                    onClose={() => setOpen(false)}
                                    options={listChangeToOptions}
                                    icon={'list-view'}
                                    variant={'arrow'}
                                    isFitWindow
                                    directionHorizontal={'right'}
                                    multiple
                                />
                                }
                            </Checkbox>)}
                    </div>
                    <div
                        className={classHeader}
                    >
                        {BOARD_PUSH_NOTIFICATION_IMPORTANT}
                    </div>
                    <div className={classWrapper} onClick={onShowBoardLimitSnackbarIfNeeded}>
                        {(isKanbanchiUser ? BOARD_PUSH_NOTIFICATION_IMPORTANT_CHECKBOXES_KNB :BOARD_PUSH_NOTIFICATION_IMPORTANT_CHECKBOXES).map((cb) =>
                            <Checkbox
                                key={cb.value}
                                className={`${classChecklist} ${cb.isListSelect ? classChecklist + '--select' : ''}`}
                                checked={scopeList.includes(cb.value as EPushNotificationSettingsScope)}
                                disabled={isReadonly}
                                value={cb.value as EPushNotificationSettingsScope}
                                onChange={(e) => onScopeChangeHandler(cb.value as EPushNotificationSettingsScope)}
                            >
                                {cb.title}
                                {cb.isListSelect &&
                                <Select
                                    disabled={isReadonly}
                                    className={`${classSelect} ${classSelect}--${cb.value} ${!onListMoveToToggle.length ? classSelect + '--empty' : ''}`}
                                    dropdownClassName={className + '-select-dropdown'}
                                    onChange={(e) => {
                                        const { value } = e.target as HTMLOptionElement;
                                        onListMoveToToggle(parseInt(value));
                                    }}
                                    onOpen={() => setOpen(true)}
                                    onClose={() => setOpen(false)}
                                    options={listMoveToOptions}
                                    icon={'list-view'}
                                    variant={'arrow'}
                                    isFitWindow
                                    directionHorizontal={'right'}
                                    multiple
                                />
                                }
                            </Checkbox>)}
                    </div>
                </>
            }
        </div>
    );
};
